"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverCarouselCard: function() {
        return _index.TeachingPopoverCarouselCard;
    },
    renderTeachingPopoverCarouselCard_unstable: function() {
        return _index.renderTeachingPopoverCarouselCard_unstable;
    },
    teachingPopoverCarouselCardClassNames: function() {
        return _index.teachingPopoverCarouselCardClassNames;
    },
    useTeachingPopoverCarouselCardStyles_unstable: function() {
        return _index.useTeachingPopoverCarouselCardStyles_unstable;
    },
    useTeachingPopoverCarouselCard_unstable: function() {
        return _index.useTeachingPopoverCarouselCard_unstable;
    }
});
const _index = require("./components/TeachingPopoverCarouselCard/index");
